import { configureStore } from '@reduxjs/toolkit';
import authReducer from '@/features/auth/model/auth.slice';
import profileReducer from '@/features/profile/model/profile.slice';
import eventsReducer from '@/features/events/model/events.slice';
import inviteReducer from '@/features/invite/model/invite.slice';
import bookingReducer from '@/features/booking/model/booking.slice';
import rolesReducer from '@/features/roles/model/roles.slice';
import friendsReducer from '@/features/friends/model/frends.slice';
import historyReducer from '@/features/history-games/model/history-games.slice';
import buyGoldReducer from '@/features/buyGold/model/buyGold.slice';
import leaderboardReducer from '@/features/leaderboard/model/leaderboard.slice';
import immunityReducer from '@/features/buyImmunity/model/buyImmunity.slice';
import subscriptionsReducer from '@/features/subscriptions/model/subscriptions.slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    events: eventsReducer,
    invite: inviteReducer,
    booking: bookingReducer,
    roles: rolesReducer,
    friends: friendsReducer,
    history: historyReducer,
    buyGold: buyGoldReducer,
    leaderboard: leaderboardReducer,
    immunity: immunityReducer,
    subscriptions: subscriptionsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
